import styles from "./Button.module.css";
import { Link } from "react-router-dom";

export default function Button(props) {
  const inverted = props.inverted || false;
  const isDisabled = props.disabled || false;

  return (
    <button
      onClick={isDisabled ? () => {} : props.onClick || undefined}
      className={` ${
        isDisabled
          ? styles[`disabled`]
          : inverted
          ? styles[`inverted`]
          : styles[`button`]
      } 
        
       `}
      {...props}
    >
      <div className={styles.text}> {props.children}</div>
    </button>
  );
}

/*className={`${
        inverted && !isDisabled ? styles.inverted : styles.button
      } ${styles[isDisabled && `disabled`]}`}*/
